export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
}

export enum LinkExtractorType {
  Text = "text",
  Html = "html",
  Json = "json",
}

export enum ContentExtractorFieldType {
  Text = "text",
  Html = "html",
}

export enum ContentTakeMode {
  First = "first",
  Last = "last",
  Normal = "normal",
}

export enum SubmitConfigType {
  Store = "store",
  Request = "request",
}

export enum TransformerType {
  Trim = "trim",
  Uppercase = "uppercase",
  Lowercase = "lowercase",
  Replace = "replace",
  Substring = "substring",
  Slice = "slice",
  Split = "split",
  PadEnd = "padEnd",
  PadStart = "padStart",
}

export const TRANSFORMER_TYPE_ORDER: TransformerType[] = [
  TransformerType.Trim,
  TransformerType.Uppercase,
  TransformerType.Lowercase,
  TransformerType.Replace,
  TransformerType.Substring,
  TransformerType.Slice,
  TransformerType.Split,
  TransformerType.PadEnd,
  TransformerType.PadStart,
];

export const HTTP_METHOD_OPTIONS: HttpMethod[] = [
  HttpMethod.GET,
  HttpMethod.POST,
  HttpMethod.PUT,
];

export const LINK_EXTRACTOR_TYPE_OPTIONS: LinkExtractorType[] = [
  LinkExtractorType.Text,
  LinkExtractorType.Html,
  LinkExtractorType.Json,
];

export const CONTENT_FIELD_TYPE_OPTIONS: ContentExtractorFieldType[] = [
  ContentExtractorFieldType.Text,
  ContentExtractorFieldType.Html,
];

export const CONTENT_TAKE_MODE_OPTIONS: ContentTakeMode[] = [
  ContentTakeMode.First,
  ContentTakeMode.Last,
  ContentTakeMode.Normal,
];

export type CronPreset = { labelKey: string; value: string };

/** Preset cron expressions; labels from i18n `scraperForm.cronPreset.<labelKey>`. */
export const CRON_PRESETS: CronPreset[] = [
  { labelKey: "everyMinute", value: "* * * * *" },
  { labelKey: "every10Min", value: "*/10 * * * *" },
  { labelKey: "every30Min", value: "*/30 * * * *" },
  { labelKey: "hourly", value: "0 * * * *" },
  { labelKey: "every6Hours", value: "0 */6 * * *" },
  { labelKey: "every12Hours", value: "0 */12 * * *" },
  { labelKey: "daily", value: "0 0 * * *" },
  { labelKey: "weekly", value: "0 0 * * 0" },
];

export enum ReplaceMatchMode {
  First = "first",
  All = "all",
}
